var map = {
	"./arrow-back.svg": "b8a8",
	"./arrow-forward.svg": "e1cd",
	"./arrow-left.svg": "ac3b",
	"./arrow-right.svg": "cd8c",
	"./briefcase.svg": "24c9",
	"./burger.svg": "ada2b",
	"./calculator.svg": "250e",
	"./calendar-menu.svg": "fa91",
	"./calendar-plus.svg": "b747",
	"./calendar.svg": "b8bd",
	"./check-small.svg": "7677",
	"./check.svg": "7bae",
	"./checkboxes.svg": "3de8",
	"./checkmark-circle.svg": "478a",
	"./chevron-double-right.svg": "ae48",
	"./chevron-down-small.svg": "1d15",
	"./chevron-down.svg": "1755",
	"./chevron-up-small.svg": "1db7",
	"./circle-strikethrough.svg": "535d",
	"./clipboard.svg": "4247",
	"./clock.svg": "755b",
	"./close.svg": "8b1b",
	"./comment.svg": "c47d",
	"./cross-circle.svg": "e798",
	"./dotted-horizontal.svg": "13a9",
	"./dotted.svg": "bc1c",
	"./download.svg": "f28e",
	"./drag-handler.svg": "e86e",
	"./edit.svg": "daf0",
	"./email.svg": "43be",
	"./equal.svg": "617d",
	"./eraser.svg": "3b6f",
	"./eye-closed.svg": "f094",
	"./eye.svg": "7364",
	"./favorite-filled.svg": "1e7c",
	"./favorite.svg": "2bd7",
	"./filters.svg": "1d60",
	"./gear.svg": "f571",
	"./google.svg": "d950",
	"./history.svg": "14e1",
	"./info.svg": "76ed",
	"./laptop-pencil.svg": "5bbd",
	"./letter-a.svg": "cb38",
	"./link.svg": "40a1",
	"./list.svg": "99ad",
	"./live.svg": "aa5f",
	"./minus.svg": "3e24",
	"./multiple-dots.svg": "6ff5",
	"./number-1.svg": "9723",
	"./paperclip.svg": "b308",
	"./pause.svg": "644b",
	"./pencil.svg": "e51f",
	"./people.svg": "1a5b",
	"./phone.svg": "c3bb",
	"./play.svg": "dab1",
	"./plus.svg": "eb38",
	"./product-archery-1.svg": "4966",
	"./product-archery-2.svg": "90bc",
	"./product-archery-3.svg": "117f",
	"./product-archery-4.svg": "6271",
	"./product-archery-5.svg": "4ca8",
	"./product-archery-6.svg": "98e6",
	"./product-archery-7.svg": "0599",
	"./product-archery-8.svg": "66c8",
	"./product-archery-9.svg": "1d67",
	"./product-axe-1.svg": "dcf2",
	"./product-axe-2.svg": "82ee",
	"./product-axe-3.svg": "cb4c",
	"./product-axe-4.svg": "787f",
	"./product-axe-firefighter.svg": "1360",
	"./product-axe-hatchet.svg": "b2ee",
	"./product-axe-swing.svg": "65b5",
	"./product-axe-tool.svg": "6fe7",
	"./product-billiards.svg": "6484",
	"./product-bowling-1.svg": "fd40",
	"./product-bowling-2.svg": "178d",
	"./product-bowling-3.svg": "0da6",
	"./product-bowling-alley.svg": "ec70",
	"./product-gun-1.svg": "6ab2",
	"./product-gun-2.svg": "6818",
	"./product-rifle.svg": "fc59",
	"./product-wheel.svg": "d73b",
	"./rectangle.svg": "3bba",
	"./reload.svg": "b9c2",
	"./restart.svg": "48ae",
	"./search.svg": "d103",
	"./settings.svg": "9174",
	"./share-network.svg": "5b9c",
	"./sign-out.svg": "8e2f",
	"./sort.svg": "f931",
	"./sortable.svg": "99f6",
	"./statistic.svg": "508c",
	"./trash.svg": "af22",
	"./users.svg": "d956",
	"./warning.svg": "daa9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";